var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"mainView"},[_c('SidebarMenu',{attrs:{"is-saas":_vm.isSaas}}),_c('el-main',{staticClass:"main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }